<template>
    <h1 class="title">{{ title }}</h1>
</template>
<script setup>
import { useNuxtApp, useHead, useSeoMeta, computed } from '#imports';

const { $i18n } = useNuxtApp();
const ogImageSize = 500;

const props = defineProps({
    title: {
        type: String,
        required: false,
        default: '',
    },
    meta: {
        type: Object,
        required: false,
        default: () => ({}),
    },
    useSiteTitle: {
        type: Boolean,
        required: false,
        default: true,
    },
});

const getImage = computed(() => {
    if (typeof (props.meta.ogImage?.[0]) === 'object') {
        const source = props.meta.ogImage[0].src;

        return source.replace(/\width=.*/, `width=${ogImageSize}`);
    }

    return null;
});

const dynamicTitleTemplate = computed(() => {
    if (props.useSiteTitle) {
        return props.title ? `${props.title} | ${$i18n.t('site.title')}` : $i18n.t('site.title');
    }

    return props.title;
});

useHead({
    htmlAttrs: {
        lang: $i18n.localeProperties.value.code,
    },
    titleTemplate: dynamicTitleTemplate,
});

useSeoMeta({
    robots: props.meta.noIndex === true ? 'noindex, nofollow' : 'index, follow',
    description: props.meta.description ?? null,
    ogTitle: props.meta.ogTitle ?? null,
    ogDescription: props.meta.ogDescription ?? null,
    ogImage: getImage.value ?? null,
});
</script>
<script>
export default {
    inheritAttrs: false,
};
</script>
<style scoped>
.title {
  position: absolute;
  top: 0;
  transform: translateY(-100%);
}
</style>
